import { Button } from '@/components/ui/button';

export interface PaymentInstructionsModalProps {
  readonly open: boolean;
  readonly onRefresh: () => void;
  readonly onClose: () => void;
  readonly isRefreshing: boolean;
  readonly refreshLabel: string;
  readonly refreshingLabel: string;
  readonly closeLabel: string;
  readonly title: string;
  readonly description: string;
}

const PaymentInstructionsModal = ({
  open,
  onRefresh,
  onClose,
  isRefreshing,
  refreshLabel,
  refreshingLabel,
  closeLabel,
  title,
  description,
}: PaymentInstructionsModalProps) => {
  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
      <div className="w-full max-w-lg rounded-lg bg-white p-6 shadow-lg">
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        <p className="mt-2 text-sm text-gray-600">{description}</p>
        <div className="mt-6 flex flex-wrap gap-2">
          <Button
            type="button"
            onClick={onRefresh}
            disabled={isRefreshing}
            className="inline-flex items-center justify-center rounded-md bg-brand-green px-4 py-2 text-white font-semibold transition hover:bg-brand-green/90 disabled:cursor-not-allowed disabled:opacity-70"
          >
            {isRefreshing ? refreshingLabel : refreshLabel}
          </Button>
          <Button type="button" onClick={onClose} variant="outline">
            {closeLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentInstructionsModal;
